<template>
  <b-row align-v="end" align-h="between" class="row mx-0">
    <div
      v-if="collapsed"
      class="w-auto px-0 hp-sidebar-collapse-button mb-8"
      @click="sidebarCollapsed(false)"
    >
      <div
        v-if="this.$store.state.themeConfig.sidebarCollapseButton"
        class="hp-cursor-pointer"
      >
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <defs />
          <path
            d="M11.08,0.584 C11.404,0.546 13.2,0.598 13.582,0.655 C15.575,0.955 17.337,1.687 18.917,2.871 C19.562,3.355 20.677,4.476 21.162,5.128 C22.382,6.757 23.148,8.68 23.38,10.702 C23.458,11.371 23.458,12.629 23.38,13.298 C23.189,14.946 22.645,16.533 21.786,17.952 C20.926,19.392 19.392,20.926 17.952,21.786 C16.081,22.904 14.153,23.44 12,23.44 C9.847,23.44 7.918,22.904 6.048,21.786 C4.6,20.921 3.083,19.404 2.213,17.952 C1.098,16.09 0.56,14.153 0.56,12 C0.56,9.847 1.098,7.91 2.213,6.048 C3.067,4.623 4.52,3.159 5.965,2.268 C7.366,1.404 9.017,0.82 10.56,0.643 Z M13.62,2.595 C12.997,2.483 11.363,2.452 10.74,2.54 C8.598,2.843 6.742,3.766 5.239,5.277 C3.844,6.678 2.949,8.405 2.594,10.38 C2.511,10.842 2.501,11.022 2.501,12 C2.501,12.974 2.511,13.159 2.593,13.612 C2.87,15.184 3.53,16.664 4.514,17.92 C4.829,18.326 5.583,19.09 6,19.426 C7.335,20.494 8.928,21.191 10.618,21.446 C11.408,21.567 12.592,21.567 13.382,21.446 C15.395,21.148 17.26,20.214 18.704,18.78 C18.97,18.516 19.301,18.157 19.439,17.981 C20.554,16.565 21.229,14.977 21.458,13.226 C21.539,12.61 21.539,11.39 21.458,10.774 C21.234,9.034 20.535,7.389 19.438,6.019 C19.107,5.599 18.345,4.844 17.92,4.514 C16.665,3.532 15.189,2.874 13.62,2.595 Z M12.95,7.23 C13.318,6.861 13.629,6.56 13.64,6.56 C14.56,7.46 15.473,8.367 16.38,9.28 L19.1,12 L16.37,14.73 L13.64,17.46 L12.96,16.78 L12.28,16.101 L13.85,14.53 L15.42,12.96 L6.28,12.96 L6.28,11.04 L15.42,11.04 L13.85,9.47 L12.28,7.9 Z"
          />
        </svg>
      </div>
    </div>

    <div class="w-auto px-0">
      <logo v-if="!collapsed" />
      <div v-else class="hp-header-logo">
        <b-link to="/" class="position-relative">
          <img
            class="hp-logo"
            v-bind:src="require('@/assets/img/logo/logo-small.svg')"
            alt="logo"
          />
        </b-link>
      </div>
    </div>

    <div
      v-if="!collapsed"
      class="w-auto px-0 hp-sidebar-collapse-button mb-4"
      @click="sidebarCollapsed(true)"
    >
      <div
        v-if="this.$store.state.themeConfig.sidebarCollapseButton"
        class="hp-cursor-pointer"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs />
          <path
            d="M11.08,0.584 C11.404,0.546 13.2,0.598 13.582,0.655 C15.575,0.955 17.337,1.687 18.917,2.871 C19.562,3.355 20.677,4.476 21.162,5.128 C22.382,6.757 23.148,8.68 23.38,10.702 C23.458,11.371 23.458,12.629 23.38,13.298 C23.189,14.946 22.645,16.533 21.786,17.952 C20.926,19.392 19.392,20.926 17.952,21.786 C16.081,22.904 14.153,23.44 12,23.44 C9.847,23.44 7.918,22.904 6.048,21.786 C4.6,20.921 3.083,19.404 2.213,17.952 C1.098,16.09 0.56,14.153 0.56,12 C0.56,9.847 1.098,7.91 2.213,6.048 C3.067,4.623 4.52,3.159 5.965,2.268 C7.366,1.404 9.017,0.82 10.56,0.643 Z M13.62,2.595 C12.997,2.483 11.363,2.452 10.74,2.54 C8.598,2.843 6.742,3.766 5.239,5.277 C3.844,6.678 2.949,8.405 2.594,10.38 C2.511,10.842 2.501,11.022 2.501,12 C2.501,12.974 2.511,13.159 2.593,13.612 C2.87,15.184 3.53,16.664 4.514,17.92 C4.829,18.326 5.583,19.09 6,19.426 C7.335,20.494 8.928,21.191 10.618,21.446 C11.408,21.567 12.592,21.567 13.382,21.446 C15.395,21.148 17.26,20.214 18.704,18.78 C18.97,18.516 19.301,18.157 19.439,17.981 C20.554,16.565 21.229,14.977 21.458,13.226 C21.539,12.61 21.539,11.39 21.458,10.774 C21.234,9.034 20.535,7.389 19.438,6.019 C19.107,5.599 18.345,4.844 17.92,4.514 C16.665,3.532 15.189,2.874 13.62,2.595 Z M7.62,9.28 C9.116,7.784 10.349,6.56 10.359,6.56 C10.596,6.777 10.826,7 11.05,7.23 L11.72,7.899 L10.15,9.47 L8.58,11.04 L17.72,11.04 L17.72,12.96 L8.58,12.96 L10.15,14.53 L11.72,16.101 L11.04,16.78 L10.36,17.46 L7.63,14.73 L4.9,12 Z"
          />
        </svg>
      </div>
    </div>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BLink } from "bootstrap-vue";
import Logo from "../../logo";

export default {
  props: ["collapsed"],
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    Logo,
  },
  methods: {
    sidebarCollapsed(check) {
      this.$emit("sidebarCollapsedProps", check);
    },
  },
};
</script>
